<template lang="pug">
  div
    app-divider.margin-bottom(
      label="Acusar publicação",
      :showBorder="false",
    )
    el-row(
      type="flex",
      justify="space-between",
      v-if="showNumeroData",
      :gutter="30"
    )
      el-col(
        :span="16",
        )
        app-label(
          :label="labelNumero"
        )
        validation-provider(rules="required", v-slot="{ errors }")
          el-input.input(
            v-model="numero",
            :maxlength= "50",
            :class="{'erro' : errors.length}",
            :name="labelNumero",
            @blur="$emit('setPublicacaoNumero', numero)",
            data-vv-validate-on="change",
            data-vv-delay="5"
          )
          span.help.erro {{ errors[0] }}

      el-col(:span="8")
        app-label(
          :label="labelData"
        )
        validation-provider(rules="required", v-slot="{ errors }")
          el-date-picker.input.full-width(
            v-model="data",
            @blur="$emit('setPublicacaoData', data)",
            type="date",
            format="dd/MM/yyyy",
            value-format="dd/MM/yyyy",
            placeholder="Insira uma data",
            :class="{'erro' : errors.length}",
            :name="labelData",
            data-vv-validate-on="change",
            data-vv-delay="5"
            :picker-options="blockFutureDate? pickerOptions:false"
          )
          span.help.erro {{ errors[0] }}
    el-row.margin-medium-top(v-if="showFileUpload")
      app-label(
        :label="labelUpload"
      )
      validation-provider(:rules="isValidate", v-slot="{ errors }")
        app-anexo(
          :id="'upload-publicacao'"
          @uploadFile="uploadFile",
          :files="anexos",
          @removeFile="removeDocumento()",
          :showAnexar="verificaTamanho"
          :errors="errors"
          @downloadDocumentoCadastro="downloadDocumentoCadastro",
        )
        span.help.erro(v-if="anexos.length === 0") {{ errors[0] }}

</template>

<script>
import AppLabel from './AppLabel'
import AppAnexo from './AppAnexo'
import AppDivider from '@/components/AppDivider'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  components: {
    AppLabel,
    AppAnexo,
    AppDivider
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      anexos: this.anexoPublicacao,
      numero: this.numeroDoe,
      data: this.dataPublicacao,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  props: {
    labelNumero: {
      type: String,
      default: 'Nº do D.O.E'
    },
    labelData: {
      type: String,
      default: 'Data de Publicação'
    },
    labelUpload: {
      type: String,
      default: 'Upload da Publicação no D.O.E'
    },
    showNumeroData: {
      type: Boolean,
      default: true,
      required: false
    },
    showFileUpload: {
      type: Boolean,
      default: true,
      required: false
    },
    anexoPublicacao: {
      type: Array,
      required: false
    },
    numeroDoe: {
      type: String,
      required: false
    },
    dataPublicacao: {
      type: String,
      required: false
    },
    blockFutureDate: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isBahia () {
      return process.env.ESTADO === 'ba'
    },
    verificaTamanho () {
      return this.isBahia ? this.anexos.length < 5 : this.anexos.length < 1
    },
    isValidate () {
      return this.anexos.length === 0 ? 'required' : ''
    }
  },

  methods: {
    uploadFile (file) {
      if (this.isBahia ? this.anexos.length < 5 : this.anexos.length < 1) {
        this.anexos.push({
          key: file.response,
          nome: file.name,
          tipo: {
            id: 80,
            codigo: 'ANEXO_PUBLICACAO'
          }
        })
      }
      this.$emit('setAnexoPublicacao', this.anexos)
    },
    removeDocumento (index) {
      this.anexos.splice(index, 1)
      this.$emit('removeAnexoPublicacao')
    },
    downloadDocumentoCadastro (documento) {
      this.$emit('downloadDocumentoCadastro', documento)
    }
  }
}
</script>

<style scoped lang="scss">
.full-width {
  width: -webkit-fill-available;
}

.margin-bottom {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppPublicacao.vue